export default "__VITE_ASSET__DIsP1QMB__"